module.exports = __webpack_public_path__ + "assets/8a54a187774ab51d65f4bc9dff5664a8.svg";